/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface MaintenancePageSignature {
  Element: HTMLDivElement;
}

const UiMaintenancePageComponent = templateOnly<MaintenancePageSignature>();

export default UiMaintenancePageComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::MaintenancePage': typeof UiMaintenancePageComponent;
  }
}
